import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=145af8ea&scoped=true&"
import script from "./Store.vue?vue&type=script&lang=js&"
export * from "./Store.vue?vue&type=script&lang=js&"
import style0 from "./Store.vue?vue&type=style&index=0&id=145af8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145af8ea",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage})
